<template>
  <v-app-bar app v-if="$store.state.isUserLoggedIn" elevation="0" color="plusBackground">

    <div class="d-flex flex-row align-center justify-center" style="width: 100%;">
      <v-btn v-if="isSmallerDisplay()" icon class="hamburger-btn" aria-label="Open navigation"
        @click="$emit('open-drawer')">
        <v-icon size="26" color="plusGreyDarken4">mdi-menu</v-icon>
      </v-btn>

      <v-row>
        <v-col cols="12" class="justify-center d-flex align-center plusGreyLighten1--text">


          <v-autocomplete style="max-width: 34.438rem; flex-grow: 1;" hide-details small ref="quickSearchAutocomplete"
            v-show="!isSmallerDisplay() || mobileQuickSearchOpen" v-if="
              $store.state.selectedAcademy && $store.state.selectedAcademy != 'all'
            " :search-input="quickSearchQuery" @update:search-input="handleQuickSearchInput"
            @blur="handleQuickSearchBlur" :menu-props="{ closeOnContentClick: true }" :loading="loadingQuickSearch"
            :items="filteredQuickSearchItems" :label="$t('message.quick_search')" dense outlined rounded
            :filter="() => true" append-icon="mdi-chevron-down" prepend-inner-icon="mdi-magnify" class="plusSurface"
            icon-color="red">

            <template v-slot:item="{ item }">
              <template v-if="item.header">
                <v-list-item-header>{{ item.header }}</v-list-item-header>
              </template>
              <template v-else>
                <v-list-item @click="handleQuickSearchSelect(item)" class="pa-2">
                  <v-list-item-avatar size="30" v-if="item.type == 'member'" class="pr-0 mr-0">
                    <ImageDisplay v-if="item.image" :src="item.image" />
                    <img v-else :src="assets('default-profile-avatar.png')" />
                  </v-list-item-avatar>
                  <v-list-item-action v-if="item.type == 'visitor'" class="pl-1">
                    <v-icon color="plusGreyLighten1">mdi-target-account</v-icon>
                  </v-list-item-action>
                  <v-list-item-action v-else class="pl-1">
                    <v-icon color="plusGreyLighten1" v-if="item.icon == 'creditcard'">mdi-cash</v-icon>
                    <v-icon color="plusGreyLighten1" v-else-if="item.icon == 'users'">mdi-account-group-outline</v-icon>
                    <v-icon color="plusGreyLighten1" v-else-if="item.icon == 'documents'">mdi-text-box-outline</v-icon>
                    <v-icon color="plusGreyLighten1" v-else-if="item.icon == 'shopping'">mdi-shopping-outline</v-icon>
                    <v-icon color="plusGreyLighten1" v-else>{{ item.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content class="pa-2">
                    <span class="ml-2" v-if="item.type != 'member'">{{
                      item.text
                      }}</span>
                    <span v-else>{{ item.text }}</span>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </template>
          </v-autocomplete>
        </v-col>


      </v-row>
      <div class="d-flex align-center actions-container">
        <div>
          <v-btn v-if="
            isSmallerDisplay() &&
            $store.state.selectedAcademy &&
            $store.state.selectedAcademy != 'all'
            && !mobileQuickSearchOpen
          " icon :aria-label="$t('message.quick_search')" @click="toggleMobileQuickSearch">
            <v-icon size="22" color="plusGreyDarken4">
              {{ mobileQuickSearchOpen ? "mdi-close" : "mdi-magnify" }}
            </v-icon>
          </v-btn>
        </div>
        <div v-if="paymentsReady && !mobileQuickSearchOpen" v-allowed="'view_payment_alerts'"
          class="ml-1 plusGreyLighten3 rounded-circle pa-2">
          <v-badge v-if="$store.state.notificationsCount > 0" overlap color="error"
            :content="$store.state.notificationsCount">
            <v-btn icon small @click="navigateTo({ name: 'notifications' })">
              <v-icon size="22" color="plusGreyDarken4">mdi-bell-outline</v-icon>
            </v-btn>
          </v-badge>
          <v-btn v-else icon small @click="navigateTo({ name: 'notifications' })">
            <v-icon size="22" color="plusGreyDarken4">mdi-bell-outline</v-icon>
          </v-btn>
        </div>
        <v-toolbar-title class="ml-1" v-if="!mobileQuickSearchOpen">
          <UserMenu :darkTheme="darkTheme" :appVersion="appVersion" :stripeAccountId="stripeAccountId"
            @toggle-theme="$emit('toggle-theme', $event)" @toggle-admin-plus="$emit('toggle-admin-plus', $event)"
            @open-feedback="$emit('open-feedback', $event)" @open-tech-support="$emit('open-tech-support', $event)"
            @logout="$emit('logout', $event)" @reload-refresh="$emit('reload-refresh', $event)"
            @copy="$emit('copy', $event)" />
        </v-toolbar-title>
      </div>
    </div>
  </v-app-bar>
</template>

<script>
import UserMenu from "@/components/layout/UserMenu.vue";

export default {
  name: "NavbarAdminPlus",
  components: {
    UserMenu,
  },
  props: {
    minimizedDrawer: {
      type: Boolean,
      default: true,
    },
    quickSearchQuery: {
      type: String,
      default: null,
    },
    loadingQuickSearch: {
      type: Boolean,
      default: false,
    },
    filteredQuickSearchItems: {
      type: Array,
      default: () => [],
    },
    paymentsReady: {
      type: Boolean,
      default: false,
    },
    darkTheme: {
      type: Boolean,
      default: false,
    },
    appVersion: {
      type: String,
      default: null,
    },
    stripeAccountId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      mobileQuickSearchOpen: false,
    };
  },
  methods: {
    /** @param {string} path */
    assets(path) {
      return require(`@/assets/${path}`);
    },
    isSmallerDisplay() {
      return this.$root.isSmallerDisplay ? this.$root.isSmallerDisplay() : false;
    },
    /** @param {any} value */
    handleQuickSearchInput(value) {
      this.$emit("update:quickSearchQuery", value);
    },
    toggleMobileQuickSearch() {
      this.mobileQuickSearchOpen = !this.mobileQuickSearchOpen;
      if (this.mobileQuickSearchOpen) {
        this.$nextTick(() => {
          /** @type {any} */
          const ac = this.$refs.quickSearchAutocomplete;
          if (!ac) return;

          if (typeof ac.focus === "function") {
            ac.focus();
            return;
          }

          const rootEl = ac?.$el ? ac.$el : ac;
          const input = rootEl?.querySelector?.("input");
          if (input) input.focus();
        });
      }
    },
    /** @param {any} item */
    handleQuickSearchSelect(item) {
      this.goToQuickSearchItem(item);
      if (this.isSmallerDisplay()) this.mobileQuickSearchOpen = false;
    },
    handleQuickSearchBlur() {
      if (!this.isSmallerDisplay()) return;
      // Small delay so clicks on menu items still register before collapsing.
      window.setTimeout(() => {
        if (this.isSmallerDisplay()) this.mobileQuickSearchOpen = false;
      }, 120);
    },
    /** @param {any} item */
    goToQuickSearchItem(item) {
      this.$emit("go-to-quick-search-item", item);
    },
    /** @param {any} route */
    navigateTo(route) {
      this.$emit("navigate", route);
    },
  },
};
</script>

<style scoped>
.hamburger-btn {
  position: absolute;
  left: 0.75rem;
}

/* .mobile-search-btn {
  position: absolute;
  left: 3.1rem;
} */

.actions-container {
  position: absolute;
  right: 1.3rem;
  top: 0;
  bottom: 0;
}
</style>
